import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { useCountries } from "src/shared/contacts/countries/useCountries";
import type { Country } from "src/shared/objects/Country";

export const useCountriesMap = (
  options?: UseQueryOptions<
    Record<string, Country>,
    unknown,
    Record<string, Country>,
    ["countries", "map"]
  >,
) => {
  const { data: countries } = useCountries();
  return useQuery(
    ["countries", "map"],
    () => {
      return Object.fromEntries(
        countries.map((country) => [country.countryCode, country]),
      );
    },
    {
      ...options,
      enabled:
        Boolean(countries) &&
        (options.enabled === undefined || options.enabled),
    },
  );
};
